<script lang="ts">
    import { setFocusOnKeyDown } from "@apps/rewards/utils/setFocusOnKeyDown";
    import { flip } from "svelte/animate";
    import { fly } from "svelte/transition";

    //Types
    type T = $$Generic;

    //Props
    export let items: Array<T & { id?: number }>;

    //Optional props
    export let selector = "button";
    export let isFocusable = false;
    export let layout: "default" | "page" = "default";

    let element: HTMLLIElement;
</script>

<ul
    class="gw-rd-list gw-list-reset-default-styles"
    class:gw-rd-list--page-layout={layout === "page"}
    aria-live="polite"
    use:setFocusOnKeyDown={{
        selector,
        observableElement: element,
        isFocusable,
    }}
>
    {#each items as item, index (item.id || index)}
        <li
            class="gw-rd-list__item"
            bind:this={element}
            in:fly|local={{ x: 400, duration: 300 }}
            animate:flip={{ duration: 800 }}
        >
            <slot {item} />
        </li>
    {:else}
        <div class="gw-rd-list__empty-state">
            <slot name="empty-state" />
        </div>
    {/each}
</ul>

<style lang="postcss">
    .gw-rd-list {
        display: grid;
        gap: var(--gw-rd-space-6);

        &--page-layout {
            grid-template-columns: repeat(auto-fit, minmax(288px, 359px));
            justify-content: start;
            gap: var(--gw-rd-space-10);

            @media (width <= 1214px) {
                justify-content: center;
            }
        }

        &__empty-state {
            grid-column: 1 / 4;

            @media (width <= 375px) {
                grid-column: 1;
            }
        }
    }
</style>
